import store from 'store'
import { b64Encode, b64Decode } from './lib'
import AppStore from '@stores/AppStore'
import HomeState from '@stores/Home'
import UserStore from '@stores/UserStore'

export const Store = {
  get: function(key) {
    return store.get(key) || {}
  },

  remove: function(key) {
    store.remove(key)
  },

  set: function(key, data) {
    store.set(key, data)
  },

  clear: function() {
    store.remove('sessionInfo')
    store.remove('liveUserInfo')
    store.remove('userInfo')
    store.remove('extra')
    store.remove('refreshTime')

    const saveInfo = store.get('saveInfo') || {}
    if (!saveInfo.save) {
      store.remove('saveInfo')
    }
  },
}

export const getStoreData = () => {
  const { styleTheme, platformName } = AppStore.theme
  const { isPcOpen, individuationKey } = AppStore
  const primary = styleTheme.palette.primary.main
  let logoUrl = Store.get('logoUrl')

  logoUrl = typeof logoUrl === 'string' ? logoUrl : ''
  logoUrl = logoUrl.indexOf('data:image/png;base64,') !== -1 ? '' : logoUrl

  return b64Encode(
    JSON.stringify({
      isSingleLogin: Store.get('isSingleLogin'),
      messageInfo: Store.get('messageInfo'),
      origin: window.location.origin,
      sessionInfo: Store.get('sessionInfo'),
      userInfo: Store.get('userInfo'),
      theme: { isPcOpen, platformName, individuationKey, logoUrl, primary },
      homeId: UserStore.homeId,
      timeGap: AppStore.timeGap,
      browserLanguage: Store.get('browserLanguage')
    })
  )
}
